import { fromPolyBool, polygonToCompoundPath, toPolyBool } from '@/modules/Editor/compoundPath'
import {
  combine,
  polygon,
  segments,
  selectDifference,
  selectUnion,
} from '@/modules/Editor/polygonOperations'
import type { Polygon } from '@/modules/Editor/AnnotationData'

const toSegment = (p: Polygon): ReturnType<typeof selectUnion> =>
  selectUnion(
    combine(segments(toPolyBool(polygonToCompoundPath(p))), { segments: [], inverted: false }),
  )

export const subtractPolygons = (cutter: Polygon, target: Polygon): Polygon => {
  const result = fromPolyBool(
    polygon(selectDifference(combine(toSegment(target), toSegment(cutter)))),
  )
  return { path: result.path, additionalPaths: result.additionalPaths }
}
